import { render } from "./dictionary-list.vue?vue&type=template&id=74915cab&scoped=true&ts=true"
import script from "./dictionary-list.vue?vue&type=script&lang=ts"
export * from "./dictionary-list.vue?vue&type=script&lang=ts"

import "./dictionary-list.vue?vue&type=style&index=0&id=74915cab&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74915cab"]])

export default __exports__